import { Header } from 'antd/lib/layout/layout'
import {Dropdown, Avatar, PageHeader, Divider } from 'antd'
import type { MenuProps } from 'antd'
import { FC } from 'react'
import { UserOutlined } from '@ant-design/icons'

export const  HeaderMenuDesktop:FC<{fechaActual:string , items: MenuProps['items'], onClick: MenuProps['onClick'] }> = ({ fechaActual, items, onClick}) => { 
  let styleHeader:React.CSSProperties = {
      width:"100%",
      background: '#F1F1F1'   
  }

  let styleDateH3: React.CSSProperties = { 
    marginTop: "50px",
    color: "#33518D",
    fontWeight: "700 bold",
    fontFamily: "Nunito",
    fontSize: "14px",
    lineHeight: "19px",
    letterSpacing: "0em",
  }
  let cerrarCesionAnchor:React.CSSProperties = { paddingTop: "35px"  }
  let cerrarCesionAvatar:React.CSSProperties = { backgroundColor: '#002570' }

  return (

    <Header className="site-layout-background" style={styleHeader}>
      <PageHeader
        title={<h3 style={styleDateH3}>{fechaActual}</h3>}
        extra={[
          <Dropdown
            key={'endSession'}
            menu={{items, onClick}}
          >
            <a style={cerrarCesionAnchor} href="/" className="anchor-primary-right" onClick={e => e.preventDefault()} >
              <Avatar className='button-primary-right' style={cerrarCesionAvatar} icon={<UserOutlined />} />
            </a>
        </Dropdown>
        ]}
      />
      <Divider />
    </Header>
  )
}